import { BaseBuyerService } from '../../base-buyer.service';
import { BuyerSaveRequestDto } from '../dto/request/buyer-save-request.dto';
import { BuyerUpdateRequestDto } from '../dto/request/buyer-update-request.dto';
import { BuyerResponseDto } from '../dto/response/buyer-response.dto';
import userService from '../../../contextAPI/user/services/user.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class BuyerService extends BaseBuyerService {
  public async fetchBuyers(): Promise<BuyerResponseDto[]> {
    const contextIds = await userService.fetchLoggedInUserContextIds();
    const response = await this.get<BuyerResponseDto[]>(`/organization/buyers`);
    const buyers = response.data;

    if (contextIds.length === 0) {
      return buyers;
    }

    return buyers.filter((buyer) => contextIds.includes(buyer.id));
  }
  public async fetchBuyerById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<BuyerResponseDto> {
    const response = await this.get<BuyerResponseDto>(`/organization/${id}`, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }
  public async fetchBuyerConvenors(): Promise<BuyerResponseDto[]> {
    const response = await this.get<BuyerResponseDto[]>(
      `/organization/conveners`
    );
    return response.data;
  }
  public async fetchBuyerSuperconvenors(): Promise<BuyerResponseDto[]> {
    const response = await this.get<BuyerResponseDto[]>(
      `/organization/consortiums`
    );
    return response.data;
  }

  public async saveBuyer(
    saveRequest: BuyerSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<BuyerResponseDto> {
    const response = await this.post<BuyerResponseDto>(
      `/organization`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateBuyer(
    updateRequest: BuyerUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<BuyerResponseDto> {
    const response = await this.put<BuyerResponseDto>(
      `/organization`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteBuyer(existingId: string): Promise<void> {
    await this.delete<void>(`/organization/${existingId}`);
  }
}

const buyerService = new BuyerService();
export default buyerService;
